import { render, staticRenderFns } from "./UnsupportBrowser.vue?vue&type=template&id=15dfd6cd&"
import script from "./UnsupportBrowser.vue?vue&type=script&lang=ts&"
export * from "./UnsupportBrowser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports